import * as React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import Bottom from "./Bottom";
import Top from './Top';
import MoreInfo from "./MoreMenu/MoreInfo";
import MoreList from "./MoreMenu/MoreList";
import Typography from '@mui/material/Typography';
import careStore from "../store/careStore";
import {useEffect} from "react";

const MoreMenu = () => {
  const storeData1: any = careStore();
  
  useEffect(() => {
    
    return () => {
      storeData1.setCareInfo('height', 0);
      storeData1.setCareInfo('weight', 0);
      storeData1.setCareInfo('reset', '');
    }
  }, []);
    
  return (
    
       <Stack sx={{ width: '100%', minWidth:320, background:'#F1F2F4', pb:10,  boxSizing:'border-box'}} spacing={6}>
          <Stack position="fixed" justifyContent={'center'} alignItems={'center'}  width={'100%'} sx={{background:'#fff', boxShadow:'none', borderBottom:'1px solid #ccc',minHeight:'56px', zIndex:99 }}>
            <Typography
                  noWrap
                  textAlign="center"
                  sx={{
                    display: { xs: 'flex', md: 'none' },
                    flexGrow: 1,
                    fontWeight: 700,
                    color: '#777',
                    textDecoration: 'none',
                    justifyContent:'center',
                    fontSize:'20px',
                    alignItems:'center'
                  }}
                >
                  전체
            </Typography>
          </Stack>
          <Stack  sx={{pl:2, pr:2, boxSizing:'border-box'}}>       
            <MoreInfo/>
            <MoreList />
          </Stack> 
        
        <Bottom />  
      </Stack>

  );
}

export default MoreMenu;